import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

 const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();

  // from auth0 tutorial for react 18/router 6
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  //const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL;
   const redirectUri = window.location.origin;
  console.log("in Auth0ProviderWithNavigate: domain, clientID, redirectUri",  domain, clientId, redirectUri);

  const onRedirectCallback = (appState) => {
    console.log('Auth0ProviderWithNavigate - onRedirectCallback:', appState);
    // navigate(appState?.returnTo || '/dashboard');
     navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId)) {
    // Be loud if misconfigured, don't render a blank page
    return (
      <div style={{ padding: 16, color: '#b00020', fontFamily: 'monospace' }}>
        Auth0 misconfigured: missing REACT_APP_AUTH0_DOMAIN or REACT_APP_AUTH0_CLIENT_ID.
      </div>
    );
  }

  return (
    <div>
    <Auth0Provider // this is per Auth0 quickstart guide
      domain={domain}
      clientId={clientId} // in auth0 each application gets a unique clientID
      authorizationParams={{
        // redirect_uri: process.env.REACT_APP_AUTH0_REDIRECT_URI,
        //redirect_uri: window.location.origin,
        redirect_uri: window.location.origin, 
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: 'openid profile email' // what do each of these do?
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback} // not clear why this is needed 
    >
      {children}
    </Auth0Provider>
    </div>
  );
};

export default Auth0ProviderWithNavigate;